package com.daytimegaming.ourdailyfinances.data.settings

import kotlinx.browser.localStorage

class WebSettingsManager : SettingsManager {
    override fun isStaging(): Boolean = getBoolean("staging", false)
    override fun setStaging(enabled: Boolean) = setBoolean("staging", enabled)
    override fun isDebug(): Boolean = false

    override fun getDashboardOrder(userId: String): List<String> =
        getString("dashboard_order_$userId")?.split(",")?.filter { it.isNotEmpty() } ?: emptyList()

    override fun setDashboardOrder(userId: String, order: List<String>) =
        setString("dashboard_order_$userId", order.joinToString(","))

    override fun getBudgetOrder(userId: String): List<String> =
        getString("budget_order_$userId")?.split(",")?.filter { it.isNotEmpty() } ?: emptyList()

    override fun setBudgetOrder(userId: String, order: List<String>) =
        setString("budget_order_$userId", order.joinToString(","))

    override fun getAccountOrder(userId: String): List<String> =
        getString("account_order_$userId")?.split(",")?.filter { it.isNotEmpty() } ?: emptyList()

    override fun setAccountOrder(userId: String, order: List<String>) =
        setString("account_order_$userId", order.joinToString(","))

    override fun getRecurringTransactionsSort(): String =
        getString("recurring_sort") ?: "RECENT"

    override fun setRecurringTransactionsSort(sortType: String) =
        setString("recurring_sort", sortType)

    private fun getBoolean(key: String, defaultValue: Boolean): Boolean =
        localStorage.getItem(key)?.toBoolean() ?: defaultValue

    private fun setBoolean(key: String, value: Boolean) =
        localStorage.setItem(key, value.toString())

    private fun getString(key: String): String? =
        localStorage.getItem(key)

    private fun setString(key: String, value: String) =
        localStorage.setItem(key, value)
}
